export default __webpack_public_path__ + "static/media/redcompra-logo.ffac2e6d.png";